import AmericanPageLayout from "components/company/v3/layouts/AmericanPageLayout";
import AmericanEventsBox from "components/company/v3/american/boxes/AmericanEventsBox";
import { CompanyEventsTabEnum } from "components/company/v3/menu/enums";
import { WrapperAmplitudeCompanyTab } from "components/company/v3/WrapperCompany";
import { EventsCalendarFilterRange } from "components/investorrelations/enums";
import useEventsCalendarState from "components/investorrelations/hooks/useEventsCalendarState";
import SetHttpStatusCode from "lib/http/SetHttpStatusCode";
import getQueryStringValue from "lib/utils/getQueryStringValue";
import type { NextPage } from "next";
import { parseAsStringEnum, useQueryState } from "nuqs";
import NotFound from "pages/404";
import { format } from "util";
import AmericanIssuerSeo from "components/company/v3/seo/AmericanIssuerSeo";
import { useIntl } from "react-intl";
import IssuerHeaderByTickerSymbol from "components/issuers/IssuerHeaderByTickerSymbol";
import { ISecurityCountry } from "types/graphqlTypes";
import useSelfie from "lib/hooks/useSelfie";

interface AmericanEventsPageProps {
  tickerSymbol: string | null;
}

const AmericanEventsPage: NextPage<AmericanEventsPageProps> = function AmericanEventsPage({ tickerSymbol }) {
  const intl = useIntl();
  const [tab, setTab] = useQueryState(
    "tab",
    parseAsStringEnum<CompanyEventsTabEnum>(Object.values(CompanyEventsTabEnum)).withDefault(
      CompanyEventsTabEnum.CALENDAR,
    ),
  );

  const filterState = useEventsCalendarState({ period: EventsCalendarFilterRange.InTheYear });
  const viewer = useSelfie();
  const normalizedTickerSymbol = (tickerSymbol || "").toUpperCase();

  if (!normalizedTickerSymbol || normalizedTickerSymbol.length > 8 || /^([0-9]+)$/.test(normalizedTickerSymbol)) {
    return (
      <>
        <SetHttpStatusCode httpStatus={404} />
        <NotFound />
      </>
    );
  }

  return (
    <AmericanPageLayout tickerSymbol={normalizedTickerSymbol}>
      <WrapperAmplitudeCompanyTab category="Stocks" tab={tab} tickerSymbol={normalizedTickerSymbol}>
        <>
          <AmericanIssuerSeo
            title={intl.formatMessage({
              defaultMessage: "Dividendos",
              description: "Título da página - SEO",
              id: "CXcewN",
            })}
            description={intl.formatMessage({
              defaultMessage:
                "Histórico completo de dividendos e JCP, com valores, data com, data de pagamento e o Dividend Yield (DY) atualizado.",
              id: "L53IMM",
              description: "Descrição da página de dividendos de uma empresa - SEO",
            })}
          />
          {!viewer && (
            <IssuerHeaderByTickerSymbol
              country={ISecurityCountry.Us}
              tickerSymbol={normalizedTickerSymbol}
              className="pb-6"
              title={intl.formatMessage({ defaultMessage: "Dividendos", id: "A7Fc1J" })}
              description={intl.formatMessage({
                defaultMessage:
                  "Confira abaixo a tabela completa e atualizada com todo histórico de dividendos pagos, declarados, etc",
                id: "xBVNop",
              })}
            />
          )}
          <AmericanEventsBox
            key={format("events/%s/%s", tickerSymbol, tab)}
            tickerSymbol={normalizedTickerSymbol}
            tab={tab}
            onChangeTab={setTab}
            {...filterState}
          />
        </>
      </WrapperAmplitudeCompanyTab>
    </AmericanPageLayout>
  );
};

AmericanEventsPage.getInitialProps = async ({ query }) => ({
  tickerSymbol: getQueryStringValue(query, "tickerSymbol"),
});

export default AmericanEventsPage;
